import React from 'react';
const PAYER_DETAILS='Payer Details';
export const PaymentPreferenceHeader = () => {
	return <h4 className='header'>{PAYER_DETAILS}</h4>;
};
